export default "__VITE_ASSET__41e3bef4__"